import React from 'react'
import { Container, Image } from 'semantic-ui-react'
import PageHeader from '../components/PageHeader'
import ShowReviews from '../components/ShowReviews'
export default function About() {
  return (
    <>
      <PageHeader
        title="About Us"
        description="Trusted Local Expert"
        image="/images/overview.jpg"
        backgroundPositionY="10"
      />
      <Container className="about-us-page">
        <div style={{ maxWidth: '1000px', marginBottom: '35px' }}>
          <p>
            Clark Tree Services is a veteran-owned business founded in 2008 by
            Daniel Clark with a single mission: to become a trusted, key
            provider of tree services for Darnestown, MD, and the surrounding
            communities. Before Clark Tree Services, there was Daniel Clark—a
            local native and a U.S. Army Veteran whose values of discipline,
            safety, and hard work laid the foundation for our company culture.
          </p>
          <Image src="/images/about-ssg.jpg" floated="right" />
          <div style={{ marginBottom: '25px' }}>
            <h2>From Military to Tree Care</h2>
            <p>
              Daniel served in the United States Army for 10 years. During his
              service, he was trained in high-risk technical operations,
              including climbing telephone and antenna towers, pole installation
              and removal, and operating crane bucket trucks. He completed two
              overseas tours, totaling over 28 months of mobilized active duty.
              When he returned, he channeled those specialized climbing skills
              and military discipline into the arboriculture industry, ensuring
              that every tree service provided is safe, efficient, and
              professional.
            </p>
          </div>

          <Image src="/images/about-family.jpg" floated="left" />
          <div>
            <h2>A Personal Touch</h2>
            <p>
              {`Daniel's commitment to his community extends beyond his business.
            He supports the Rockville Civic Ballet where he dances in multiple performances a year. 
            He and his family, his wife and five kids, have performed in
            several productions such as "FireBird", "Dante's Inferno", and "The NutCracker".`}
            </p>
          </div>

          <h2>Our Mission</h2>
          <p>
            {`At Clark Tree Services, we're dedicated to providing top-notch tree care and removal
            services with a focus on customer satisfaction. Daniel's goal is to
            build long-term relationships with his clients, ensuring they feel
            confident and supported every step of the way. With a strong work
            ethic and a passion for his craft, Daniel is proud to be serving the
            Darnestown community.`}
          </p>
        </div>
      </Container>
      <ShowReviews />
    </>
  )
}
